"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownIndicator = void 0;

var _react = _interopRequireDefault(require("react"));

var _rebrand = require("@lt/components/icons-react/rebrand");

var _dropdownIndicatorModule = _interopRequireDefault(require("./dropdownIndicator.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DropdownIndicator = function DropdownIndicator() {
  return /*#__PURE__*/_react["default"].createElement(_rebrand.ChevronDown, {
    className: _dropdownIndicatorModule["default"].dropDown
  });
};

exports.DropdownIndicator = DropdownIndicator;